var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarClockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_23223_69125",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "currentColor"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_23223_69125)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.16669 7.33687H15.8334V5.25354C15.8334 5.18937 15.8066 5.13062 15.7531 5.07729C15.6998 5.02382 15.6411 4.99708 15.5769 4.99708H4.42315C4.35898 4.99708 4.30023 5.02382 4.2469 5.07729C4.19342 5.13062 4.16669 5.18937 4.16669 5.25354V7.33687ZM4.42315 17.9138C4.00217 17.9138 3.64585 17.7679 3.35419 17.4763C3.06252 17.1846 2.91669 16.8283 2.91669 16.4073V5.25354C2.91669 4.83257 3.06252 4.47625 3.35419 4.18458C3.64585 3.89292 4.00217 3.74708 4.42315 3.74708H5.5769V1.98438H6.85898V3.74708H13.1731V1.98438H14.4231V3.74708H15.5769C15.9979 3.74708 16.3542 3.89292 16.6459 4.18458C16.9375 4.47625 17.0834 4.83257 17.0834 5.25354V9.80646C16.8835 9.71882 16.6794 9.64799 16.4711 9.59396C16.2627 9.54007 16.0502 9.49764 15.8334 9.46667V8.58687H4.16669V16.4073C4.16669 16.4715 4.19342 16.5302 4.2469 16.5835C4.30023 16.637 4.35898 16.6638 4.42315 16.6638H9.84148C9.9119 16.8944 9.9971 17.1126 10.0971 17.3183C10.197 17.524 10.3104 17.7225 10.4375 17.9138H4.42315ZM15.1602 18.7471C14.1197 18.7471 13.2345 18.3822 12.5048 17.6525C11.7751 16.9228 11.4102 16.0376 11.4102 14.9971C11.4102 13.9565 11.7751 13.0714 12.5048 12.3417C13.2345 11.6119 14.1197 11.2471 15.1602 11.2471C16.2009 11.2471 17.0861 11.6119 17.8156 12.3417C18.5454 13.0714 18.9102 13.9565 18.9102 14.9971C18.9102 16.0376 18.5454 16.9228 17.8156 17.6525C17.0861 18.3822 16.2009 18.7471 15.1602 18.7471ZM16.5481 16.9042L17.0673 16.385L15.529 14.8465V12.5452H14.7917V15.1477L16.5481 16.9042Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarClockIcon);
export default __webpack_public_path__ + "static/media/CalendarClockIcon.ce5b4d1e7813bb8ca0770f0523e6c478.svg";
export { ForwardRef as ReactComponent };